export const ID37 = () => {
    return (
        <div>
            <div className="content" readonly=""><h1>1С:Шина</h1>

                <h2>Что такое 1С:Шина?</h2>
                <p>
                    1С:Шина — это программный продукт класса «Сервисная шина предприятия» (Enterprise Service Bus, ESB),
                    обеспечивающий обмен данными между различными
                    информационными системами, работающими как на платформе «1С:Предприятие», так и с системами на
                    других платформах.
                </p>

                <img src="https://cybernetica.kz/uploads/gallery/1721261716.png" alt=""/>

                <h2>Для чего она нужна?</h2>
                <p>
                    Перед любой информационной системой, в составе которой более одной информационной базы, встаёт
                    задача обмена информацией. Когда самих систем или маршрутов
                    обменов становится много, то могут возникать следующие проблемы:
                </p>

                <ul>
                    <li>Нестабильность работы</li>
                    <li>Высокая трудоёмкость поддержки</li>
                    <li>Отсутствие единого стандарта данных</li>
                    <li>Сложность в&nbsp;понимании местонахождения и&nbsp;статуса сообщений в&nbsp;момент времени</li>
                    <li>Рассинхронизация данных</li>
                    <li>Сложность масштабирования</li>
                </ul>

                <p>
                    1С:Шина позволяет решить эти проблемы, перенаправляя все обмены через себя и предоставляя единую
                    точку входавыхода для всех информационных систем, а также
                    единый инструмент управления и мониторинга.
                </p>

                <h2>Основные преимущества</h2>

                <ul>
                    <li>Маршрутизация сообщений</li>
                    <li>Гарантированная доставка сообщений</li>
                    <li>Обработка и преобразование сообщений</li>
                    <li>Поддержка асихронного обмена сообщений</li>
                    <li>Готовые коннекторы для различных информационных систем</li>
                    <li>Механизмы контроля и управления интеграционными потоками</li>
                    <li>Единая точка входавыхода для всех систем</li>
                    <li>Трансформация сообщений</li>
                    <li>Единый инструмент мониторинга</li>
                    <li>Удобство администрирования и поддержки</li>
                    <li>Доступ из браузера</li>
                    <li>Легкая интеграция с различными системами</li>
                </ul>

                <h2>Способы подключения</h2>
                <ul>
                    <li>
                        <h3>Веб-сервисы (SOAP)</h3>
                        <p>
                            Возможно создавать веб-сервисы на стороне 1С:Шины, а также вызывать внешний веб-сервис и
                            удобно обрабатывать полученные ответы. Для описания сервиса
                            используются WSDL-схемы.
                        </p>
                    </li>
                    <li>
                        <h3>Стандарт JMS</h3>
                        <p>
                            Возможность интегрироваться со сторонним брокером сообщений Apache ActiveMQ Artemis,
                            например, настраивать асинхронную интеграцию с SAP PI (SAP
                            NetWeaver Process Integration).
                        </p>
                    </li>
                    <li>
                        <h3>AMQP</h3>
                        <p>
                            Даёт возможность обмениваться сообщениями по протоколу AMQP версии 1.0. Кроме этого, в
                            1С:Шине предусмотрены инструменты для подключения к брокеру
                            сообщений RabbitMQ.
                        </p>
                    </li>
                    <li>
                        <h3>JDBC</h3>
                        <p>
                            Даёт возможность прямого обмена с внешними СУБД (например, MS SQL Server, PostgreSQL).
                            Возможно добавление нужных JDBC-драйверов в сервер «1С:Шины».
                        </p>
                    </li>
                    <li>
                        <h3>Сервисы интеграции</h3>
                        <p>
                            Встроенный в платформу «1С:Предприятие» механизм, позволяющий обмениваться сообщениями через
                            1С:Шину. Платформа, совместно с 1С:Шиной, обеспечивает
                            гарантированную доставку сообщений при простоте использования.
                        </p>
                    </li>
                    <li>
                        <h3>Обмен сообщениями в виде файлов</h3>
                        <p>Предоставляет возможность обмениваться файлами, подключаясь к файловым хранилищам, каталогам,
                            в том числе сетевым, и различным FTP-ресурсам.</p>
                    </li>
                    <li>
                        <h3>HTTP</h3>
                        <p>
                            Можно создавать собственные HTTP-сервисы для обработки входящих HTTP-запросов от внешних
                            информационных систем. Также можно подключаться к сторонним
                            HTTP-сервисам через специальный узел, отправлять запросы к внешним ресурсам и формировать
                            исходящие сообщения на основе результатов этих запросов.
                            Функциональность HTTP-протокола также позволяет использовать обмен данными в соответствии с
                            существующим REST API.
                        </p>
                    </li>
                </ul>

                <h2>Функциональные возможности</h2>
                <h3>Среда разработки</h3>
                <p>
                    Среда разработки работает в браузере, позволяет декларативно создавать схемы интеграции и писать,
                    отлаживать и рефакторить код. Поддерживается групповая
                    разработка и подключение к Gitlab. Встроенный синтакс-помощник и документация облегчают процесс
                    разработки.
                </p>

                <h3>Панель управления</h3>
                <p>
                    Панель управления — это инструмент администратора 1С:Шины. Она позволяет запускать и останавливать
                    приложения, которые содержат схемы интеграции, позволяет
                    выполнять бэкапы и восстановление, управлять пользователями и проектами приложений, а также
                    выполнять обновления и управлять базами данных и репозиториями.
                </p>
                <h3>Мониторинг и контроль</h3>
                <p>
                    Доступны различные инструменты контроля сообщений, включая отображение общего количества сообщений,
                    статистику по каналам и метрики процесса интеграции.
                    Также есть информация о доставленных и недоставленных сообщениях, что может быть полезно для
                    контроля и повторной отправки сообщений при необходимости.
                    Журналы событий позволяют отслеживать работу и расследовать ошибки.1
                </p>

                <h2>Варианты поставок</h2>
                <p>
                    1С:Шина поставляется в трех вариантах поставок в зависимости от числа работающих пользователей
                    информационных систем на платформе «1С:Предприятие»
                    (учитываются системы, участвующие в обменах). Пользователи систем не на платформе «1С:Предприятие»
                    не учитываются при подсчете числа пользователей
                    «1С:Шины».Продукт поставляется только в электронном формате.
                </p>

                <h3>1С:Шина для 100 пользователей. Электронная поставка</h3>

                <h3>1С:Шина для 500 пользователей. Электронная поставка</h3>

                <h3>1С:Шина без ограничений на число пользователей. Электронная поставка</h3></div>
        </div>
    )
}